<!-- Header -->
<div class="px-4 sm:px-8 pt-6 pb-2">
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px; flex-shrink: 0;">public</mat-icon>
      Beneficiarios internacionales
      <span *ngIf="totalBeneficiarios > 0"
        class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
        {{ totalBeneficiarios }} {{ totalBeneficiarios === 1 ? 'beneficiario' : 'beneficiarios' }}
      </span>
    </h1>
    <button type="button" (click)="agregar()" [disabled]="!puedeAgregar"
      [style.opacity]="puedeAgregar ? '1' : '0.5'"
      [style.cursor]="puedeAgregar ? 'pointer' : 'not-allowed'"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; min-height: 44px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">add_circle</mat-icon>
      Agregar Beneficiario
    </button>
  </div>

  <!-- Badge mobile -->
  <span *ngIf="totalBeneficiarios > 0"
    class="md:hidden inline-block text-xs font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
    {{ totalBeneficiarios }} {{ totalBeneficiarios === 1 ? 'beneficiario' : 'beneficiarios' }}
  </span>
</div>

<!-- Buscador -->
<div *ngIf="!loading && totalBeneficiarios > 0" class="px-4 sm:px-8 pb-1 pt-2">
  <div style="position: relative; max-width: 420px;">
    <mat-icon
      style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #9ca3af; font-size: 20px; width: 20px; height: 20px;">search</mat-icon>
    <input type="text" [(ngModel)]="searchTxt" (ngModelChange)="onSearchChange()"
      placeholder="Buscar por nombre, documento o banco"
      style="width: 100%; padding: 11px 38px 11px 40px; border: 1px solid #d1d5db; border-radius: 10px; font-size: 0.86rem; background: white; min-height: 44px;" />
    <button *ngIf="searchTxt" type="button" (click)="limpiarBusqueda()" aria-label="Limpiar búsqueda"
      style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #9ca3af; padding: 0; line-height: 1;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">close</mat-icon>
    </button>
  </div>
</div>

<!-- Cargando -->
<div *ngIf="loading" class="flex justify-center py-10">
  <mat-spinner diameter="32"></mat-spinner>
</div>

<!-- Error -->
<div *ngIf="!loading && error" class="px-4 sm:px-8 py-6">
  <div
    style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; padding: 16px; color: #b91c1c; font-size: 0.86rem; display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
    <mat-icon style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">error_outline</mat-icon>
    <span style="flex: 1; min-width: 180px;">{{ error }}</span>
    <button type="button" (click)="cargarBeneficiarios()"
      style="background: white; border: 1px solid #fecaca; border-radius: 8px; padding: 6px 14px; font-weight: 600; font-size: 0.8rem; color: #b91c1c; cursor: pointer;">
      Reintentar
    </button>
  </div>
</div>

<!-- Sin beneficiarios -->
<div *ngIf="!loading && !error && totalBeneficiarios === 0" class="px-4 sm:px-8 py-8">
  <div style="background: white; border-radius: 16px; padding: 48px 24px; text-align: center; border: 2px dashed #d1d5db;">
    <mat-icon
      style="font-size: 56px; width: 56px; height: 56px; color: #9ca3af; margin-bottom: 16px; flex-shrink: 0;">public</mat-icon>
    <p style="font-size: 1.1rem; font-weight: 600; color: #374151; margin: 0 0 6px;">
      No tienes beneficiarios internacionales
    </p>
    <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">
      Agrega el primero y lo vas a tener listo cuando quieras enviar al exterior
    </p>
  </div>
</div>

<!-- Búsqueda sin resultados -->
<div *ngIf="!loading && !error && totalBeneficiarios > 0 && !hayResultados" class="px-4 sm:px-8 py-8">
  <div style="background: white; border-radius: 16px; padding: 32px 24px; text-align: center; border: 1px solid #e5e7eb;">
    <p style="font-size: 0.95rem; font-weight: 600; color: #374151; margin: 0;">
      Ningún beneficiario coincide con "{{ searchTxt }}"
    </p>
    <button type="button" (click)="limpiarBusqueda()"
      style="margin-top: 10px; background: none; border: none; color: #1C593D; font-weight: 700; font-size: 0.85rem; cursor: pointer;">
      Ver todos
    </button>
  </div>
</div>

<div *ngIf="!loading && !error && hayResultados" class="px-4 sm:px-8 py-4">

  <!-- ═══ TABLA DESKTOP ═══ -->
  <div class="hidden lg:block bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
    <table mat-table [dataSource]="filtrados" [trackBy]="trackById" class="w-full">

      <!-- País -->
      <ng-container matColumnDef="pais">
        <th mat-header-cell *matHeaderCellDef>País</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; align-items: center; gap: 7px;">
            <img *ngIf="paisFlag(row)" [src]="paisFlag(row)" [alt]="paisNombre(row)"
              style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover; flex-shrink: 0;" />
            <span style="font-size: 0.82rem; font-weight: 600; color: #111827;">{{ paisNombre(row) }}</span>
          </div>
          <span *ngIf="!tieneEnvio(row)"
            style="display: inline-block; margin-top: 3px; font-size: 0.62rem; font-weight: 600; color: #92400e; background: #fef3c7; border: 1px solid #fde68a; padding: 1px 7px; border-radius: 12px;">
            Envíos no disponibles
          </span>
        </td>
      </ng-container>

      <!-- Beneficiario -->
      <ng-container matColumnDef="beneficiario">
        <th mat-header-cell *matHeaderCellDef>Beneficiario</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-weight: 700; font-size: 0.82rem; color: #111827;">{{ nombreDe(row) }}</span>
          <span style="display: block; font-size: 0.72rem; color: #6b7280;">{{ row.tipoId }} {{ row.numeroId }}</span>
        </td>
      </ng-container>

      <!-- Método -->
      <ng-container matColumnDef="metodo">
        <th mat-header-cell *matHeaderCellDef>Método</th>
        <td mat-cell *matCellDef="let row">
          <span
            style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; background: #ecfdf5; color: #166534; border: 1px solid #bbf7d0;">
            <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #16794a; flex-shrink: 0;">account_balance</mat-icon>
            {{ bancoDe(row) }}
          </span>
        </td>
      </ng-container>

      <!-- Cuenta -->
      <ng-container matColumnDef="cuenta">
        <th mat-header-cell *matHeaderCellDef>Cuenta</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-size: 0.78rem; color: #374151; font-family: monospace; font-variant-numeric: tabular-nums;">{{ cuentaDe(row) }}</span>
        </td>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="!esBaneado(row)"
            style="display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 0.68rem; font-weight: 700; background: #dcfce7; color: #166534; border: 1px solid #bbf7d0;">
            Habilitado
          </span>
          <span *ngIf="esBaneado(row)"
            style="display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 0.68rem; font-weight: 700; background: #fee2e2; color: #991b1b; border: 1px solid #fecaca;">
            No habilitado
          </span>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Acciones</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; gap: 4px; justify-content: center; flex-wrap: wrap;">
            <!-- Ver -->
            <button type="button" title="Ver ficha" (click)="verFicha(row, $event)"
              [disabled]="accionEnCurso === row.id"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
            </button>
            <!-- Editar -->
            <button type="button" [title]="esBaneado(row) ? 'Este beneficiario no está habilitado' : 'Editar'"
              (click)="editar(row, $event)" [disabled]="esBaneado(row) || accionEnCurso === row.id"
              [style.opacity]="esBaneado(row) ? '0.45' : '1'"
              [style.cursor]="esBaneado(row) ? 'not-allowed' : 'pointer'"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; transition: all 0.2s;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
            </button>
            <!-- Eliminar -->
            <button type="button" title="Eliminar" (click)="eliminar(row, $event)"
              [disabled]="accionEnCurso === row.id"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- ═══ CARDS MOBILE (colapsables) ═══ -->
  <div class="lg:hidden flex flex-col gap-3">
    <div *ngFor="let b of filtrados; trackBy: trackById" (click)="toggleCard(b.id)"
      style="background: white; border-radius: 14px; overflow: hidden; transition: all 0.2s ease;"
      [style.border]="expandedCardId === b.id ? '2px solid #1C593D' : '1px solid #e5e7eb'"
      [style.box-shadow]="expandedCardId === b.id ? '0 4px 16px rgba(28,89,61,0.1)' : '0 1px 3px rgba(0,0,0,0.06)'">

      <!-- Header siempre visible -->
      <div style="padding: 14px 16px; display: flex; align-items: center; gap: 12px; cursor: pointer;"
        [style.background]="expandedCardId === b.id ? '#f0fdf4' : 'white'">

        <img *ngIf="paisFlag(b)" [src]="paisFlag(b)" [alt]="paisNombre(b)"
          style="width: 40px; height: 40px; border-radius: 10px; object-fit: cover; flex-shrink: 0;" />
        <div *ngIf="!paisFlag(b)"
          style="display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 10px; background: #ecfdf5; flex-shrink: 0;">
          <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #16794a; flex-shrink: 0;">public</mat-icon>
        </div>

        <div style="min-width: 0; flex: 1;">
          <p
            style="font-weight: 700; font-size: 0.9rem; color: #111827; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ nombreDe(b) }}
          </p>
          <span style="font-size: 0.78rem; color: #6b7280;">{{ paisNombre(b) }}</span>
        </div>

        <span *ngIf="esBaneado(b)"
          style="background: #fee2e2; border: 1px solid #fecaca; padding: 2px 8px; border-radius: 12px; font-size: 0.62rem; font-weight: 700; color: #991b1b; flex-shrink: 0;">
          No habilitado
        </span>

        <mat-icon style="color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease;"
          [style.transform]="expandedCardId === b.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Cuerpo expandible -->
      <div *ngIf="expandedCardId === b.id">
        <div style="padding: 0 16px 12px; border-top: 1px solid #f3f4f6;">
          <div class="grid grid-cols-2 gap-3" style="padding-top: 12px;">
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Documento</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ b.tipoId }} {{ b.numeroId }}</p>
            </div>
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Cuenta</span>
              <p style="margin: 2px 0 0; font-size: 0.8rem; font-weight: 600; color: #111827; font-family: monospace;">{{ cuentaDe(b) }}</p>
            </div>
            <div class="col-span-2">
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Método</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ bancoDe(b) }}</p>
            </div>
            <div *ngIf="!tieneEnvio(b)" class="col-span-2">
              <span
                style="display: inline-block; font-size: 0.68rem; font-weight: 600; color: #92400e; background: #fef3c7; border: 1px solid #fde68a; padding: 3px 9px; border-radius: 12px;">
                Todavía no se puede enviar a este destino
              </span>
            </div>
          </div>
        </div>

        <!-- Acciones mobile -->
        <div style="padding: 10px 16px; border-top: 1px solid #f3f4f6; display: flex; gap: 8px;">
          <button type="button" (click)="verFicha(b, $event)" [disabled]="accionEnCurso === b.id"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
            Ver
          </button>
          <button type="button" (click)="editar(b, $event)" [disabled]="esBaneado(b) || accionEnCurso === b.id"
            [style.opacity]="esBaneado(b) ? '0.45' : '1'"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
            Editar
          </button>
          <button type="button" (click)="eliminar(b, $event)" [disabled]="accionEnCurso === b.id"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
